import React from 'react'
import { Breadcrumb } from 'antd'
import { withRouter } from 'react-router-dom'
import router from '../../../router/routes'

import './index.less'
export default withRouter(class BreadcrumbLink extends React.Component<any> {

	render() {
		const  { pathname } = this.props.location
		const { routes } = router[0]
		const pathnameArr = pathname.split('/')
		console.log('pathnameArr', pathnameArr)
		let parentRoute = '', childrenRoute = ''
		routes && routes.forEach(item => {
			if(item.path.indexOf(pathnameArr[2]) > -1) {
				parentRoute = item.title
				item.routes.forEach(route => {
					console.log('route', route.path)
					if (route.path === pathname) {
						!childrenRoute && (childrenRoute = route.title)
					} else if(route.path.indexOf(pathnameArr[3]) > -1) {
						!childrenRoute && (childrenRoute = route.title)
					}
				})
			}
		})
		return (
			<div className="breadcrumb-wrap">
				<Breadcrumb>
					<Breadcrumb.Item>{parentRoute}</Breadcrumb.Item>
					<Breadcrumb.Item>{childrenRoute}</Breadcrumb.Item>
				</Breadcrumb>
			</div>
		)
	}
})